module.exports = __webpack_public_path__ + "static/img/square.e0d67f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square.png
// module id = BoC9
// module chunks = 1